module.exports = __webpack_public_path__ + "img/cooperate_qy_14@2x.788b6bc4.png";